import { useState } from 'react';

import { useNavigate } from 'libs/navigation';

import { useAcceptClientAgreements } from './useAcceptClientAgreements';
import { useGetClientAgreements } from './useGetClientAgreements';

export const useAgreements = () => {
  const { searchParams } = useNavigate();

  const [activeIndex, setActiveIndex] = useState(0);

  const { agreements, loading } = useGetClientAgreements();

  const { acceptClientAgreements, loading: submitLoading } =
    useAcceptClientAgreements();

  const onAccept = async () => {
    if (agreements && activeIndex === agreements.length - 1) {
      const res = await acceptClientAgreements(agreements.map((i) => i.id));
      if (res) {
        const ret = searchParams.get('ret');
        if (ret && ret.startsWith(window.location.origin)) {
          window.location.replace(ret);
        } else {
          window.location.replace('/');
        }
      }
      return;
    }

    setActiveIndex((v) => v + 1);
  };

  return { agreements, activeIndex, loading, submitLoading, onAccept };
};
